module.exports = __webpack_public_path__ + "img/online-resume.a7d7b43c.svg";